<div class="app">
  <div class="app__inner" [class.anim--in]="!loading$()">
    @if (dictionaryLoaded$() && menuItems$()) {
      <app-topbar (toggle)="toggleMenu()" (close)="closeMenu()" (open)="openMenu()" [menuActive]="menuOpen$()" [menuItems]="menuItems$()">
        @if (isDesktop$()) {
          <app-breadcrumbs [breadCrumbs]="breadcrumbs$()"></app-breadcrumbs>
        }
      </app-topbar>
    }

    @if (!isDesktop$()) {
      <app-breadcrumbs [breadCrumbs]="breadcrumbs$()"></app-breadcrumbs>
    }

    <div class="app__router">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
    @if (dictionaryLoaded$()) {
      <app-footer></app-footer>
    }
  </div>
  <app-loader-indicator [loading]="loading$()"></app-loader-indicator>

  @if (dictionaryLoaded$()) {
    <fstr-cookie-notice
      [title]="'cookie-title' | fromDictionary"
      [text]="'cookie-text' | fromDictionary"
      [buttonAccept]="'cookie-accept' | fromDictionary"
      [buttonReject]="'cookie-reject' | fromDictionary"
    ></fstr-cookie-notice>
  }
</div>

<!-- <app-theme-switcher></app-theme-switcher> -->

@if (testOverlay) {
  <div class="grid-overlay">
    <div class="container">
      <div class="row grid-showcase">
        @for (number of gridColumns; track number) {
          <div class="col-1">
            <div class="grid-showcase__inner">
              {{ number + 1 }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
